import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 31 26",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 26\" id=\"icon-arrow--right\"><path d=\"M16.164.201a1.538 1.538 0 0 0-1.373 1.013 1.529 1.529 0 0 0 .413 1.653l9.376 8.588-24.466.002c-.054-.003 1.46-.005 1.406-.003-.804.042-1.498.81-1.456 1.613.042.802.812 1.494 1.616 1.452h22.9l-9.376 8.572a1.533 1.533 0 0 0 1.567 2.594 1.51 1.51 0 0 0 .513-.344l12.288-11.237a1.532 1.532 0 0 0 0-2.25L17.284.616a1.538 1.538 0 0 0-1.12-.415Z\" fill=\"#05191F\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol